import { RcFile } from 'antd/lib/upload/interface';
import axios from './axios';

export interface FileType extends File {
  id: string;
  mimeType?: string;
  rawFile?: FileType;
}
export const getFile = (file: FileType) => {
  return axios.get<Blob>(`/files/${file.id}`, { responseType: 'blob' });
};

export const getFileById = (id: string) => {
  return axios.get<Blob>(`/files/${id}`, { responseType: 'blob' });
};

export const uploadFile = <T = any>(data: FormData) => {
  return axios
    .post<T>('/files', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((res) => res.data);
};

export type ImageResponse = {
  id: string;
  name: string;
  mimeType: string;
};

export const uploadImage = (props: any) => {
  const { anonymous } = props;
  return (file: FileType | RcFile) => {
    const data = new FormData();
    data.append('data', file);
    if (anonymous) {
      data.append('anonymous', 'true');
    }
    return uploadFile<ImageResponse>(data);
  };
};
